import { HttpClient } from '@angular/common/http';
import { ConstantValues } from '../bpg-common/models/bpg-constants';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { BpgCommonService } from '../bpg-common/services/bpg-common.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../bpg-common/services/bpg-common.service";
var BpgExpensesService = /** @class */ (function () {
    function BpgExpensesService(http, bpgCommonService) {
        this.http = http;
        this.bpgCommonService = bpgCommonService;
        this.URI = ConstantValues.eventManagementApiUrl.eventManagementUrl;
        this.userUrl = ConstantValues.userManagementApiUrl.userManagementUrl;
        this.createExpenseApi = ConstantValues.eventManagementApiUrl.createExpense;
        this.getExpenseApi = ConstantValues.eventManagementApiUrl.getExpense;
        this.getExpenseByIdApi = ConstantValues.eventManagementApiUrl.getExpenseById;
        this.expenseStatusUpdateApi = ConstantValues.eventManagementApiUrl.expenseStatusUpdate;
        this.getSitePrimaryContactSuperAdminApi = ConstantValues.eventManagementApiUrl.getSitePrimaryContactSuperAdmin;
        this.getActualsChapterListApi = ConstantValues.userManagementApiUrl.getActualsChapterList;
        this.getActualsBPGListApi = ConstantValues.userManagementApiUrl.getActualsBPGList;
        this.getActualsSiteListApi = ConstantValues.userManagementApiUrl.getActualsSiteList;
    }
    /** For service call to save event
  * @class BpgExpensesService
  * @method saveExpense
  * @param expenseFormData
  * @returns Observable
  */
    BpgExpensesService.prototype.saveExpense = function (expenseFormData) {
        return this.http.post(this.URI + this.createExpenseApi, expenseFormData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to get expense list
* @class BpgExpensesService
* @method getExpenses
* @param landingDTO
* @returns Observable
*/
    BpgExpensesService.prototype.getExpenses = function (landingDTO) {
        return this.http.post(this.URI + this.getExpenseApi, landingDTO, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to update expense status
   * @class BpgExpensesService
   * @method updateExpenseStatus
   * @param landingDtoModel
   * @returns Observable
   */
    BpgExpensesService.prototype.updateExpenseStatus = function (landingDtoModel) {
        return this.http.post(this.URI + this.expenseStatusUpdateApi, landingDtoModel, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to get site primary contact super admin
       * @class BpgExpensesService
       * @method getSitePrimaryContactAdmins
       * @param siteId , userId
       * @returns Observable
       */
    BpgExpensesService.prototype.getSitePrimaryContactAdmins = function (sitePrimaryContactDTO) {
        return this.http.post(this.URI + this.getSitePrimaryContactSuperAdminApi, sitePrimaryContactDTO, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to get expense list
* @class BpgExpensesService
* @method getExpenses
* @param landingDTO
* @returns Observable
*/
    BpgExpensesService.prototype.getExpenseById = function (expenseId) {
        return this.http.get(this.URI + this.getExpenseByIdApi + expenseId, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to get chapter list
* @class Actuals
* @method getActualsChapterList
* @returns Observable
*/
    BpgExpensesService.prototype.getActualsChapterList = function () {
        return this.http.get(this.userUrl + this.getActualsChapterListApi, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to get BPG list
 * @class Actuals
 * @method getActualsBPGList
 * @returns Observable
 */
    BpgExpensesService.prototype.getActualsBPGList = function () {
        return this.http.get(this.userUrl + this.getActualsBPGListApi, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    BpgExpensesService.prototype.getActualsSiteList = function () {
        return this.http.get(this.userUrl + this.getActualsSiteListApi, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    BpgExpensesService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function BpgExpensesService_Factory() { return new BpgExpensesService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.BpgCommonService)); }, token: BpgExpensesService, providedIn: "root" });
    return BpgExpensesService;
}());
export { BpgExpensesService };
